import React, { Component }     from "react"
import { connect }              from "react-redux"
import { withRouter }           from "react-router-dom"
import styled                   from "styled-components"
import feedbackService          from "../../../api/feedbackService"
import {
    Heading,
    Text,
}                               from "../../../components/styled"
import { feedbackLocalization } from "../../../localization"

class Feedback extends Component {
    constructor() {
        super()

        this.state = {
            messageSuccess: false,
            messageFailed: false,
            error: {},
            isSubmitting: false,
        }
    }

    validateEmail(mail) {
        return /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(mail)

    }

    validate(data) {
        let error = {}
        this.setState({ error: {} })
        if (data.full_name.trim() === "") {
            error.full_name = {
                en: "Full Name is required",
                np: "पूरा नाम आवश्यक छ",
            }
        }

        //check if email is valid
        let isEmailValid = this.validateEmail(data.contact_email)
        if (!isEmailValid) {
            error.email = {
                en: "Email is not valid",
                np: "इमेल मिलेन",
            }
        }

        if (data.contact_email.trim() === "") {
            error.email = {
                en: "Email is required",
                np: "इ-मेल आवश्यक छ",
            }
        }

        if (data.feedback.trim() === "") {
            error.feedback = {
                en: "Feedback is required",
                np: "प्रतिक्रिया आवश्यक छ",
            }
        }

        if (Object.keys(error).length) {
            this.setState({ error })
            return false
        } else {
            // this.setState({ error: {} });
            return true
        }
    }

    resetFeedback() {
        this._inputValue.value = ""
        this._emailValue.value = ""
        this._messageValue.value = ""
    }

    handleSubmit = () => {
        const { municipality } = this.props
        const feedback = {
            full_name: this._inputValue.value,
            contact_email: this._emailValue.value,
            feedback: this._messageValue.value,
            feedback_type: "physical_progress",
            user_type: "general_public",
        }

        let isValid = this.validate(feedback)

        if (isValid) {
            const selectedProject = this.props.match.params.id
            this.setState({ isSubmitting: true });

            feedbackService
                .sendFeedbacks(selectedProject, feedback, municipality.title_en)
                .then(response => {
                    if (response.success) {
                        this.setState({ messageSuccess: true }, () => {
                            this.resetFeedback()
                            this.setState({ isSubmitting: false });
                            setTimeout(() => {
                                this.setState({ messageSuccess: false })
                            }, 3000)
                        })
                    } else {
                        this.setState({ messageFailed: true }, () => {
                            this.setState({ isSubmitting: false });
                            setTimeout(() => {
                                this.setState({ messageFailed: false })
                            }, 3000)
                        })
                    }
                })
        }
    }

    render() {
        const { messageSuccess, messageFailed } = this.state
        const localizationFeedback =
            feedbackLocalization[this.props.selectedLanguage]
        const { error } = this.state
        return (
            <FeedbackMain>
                <Heading.h2 uppercase light>
                    Feedback for this project
                </Heading.h2>
                {messageSuccess && (
                    <div className="message message--success">
                        {localizationFeedback.successMessage}
                    </div>
                )}
                {messageFailed && (
                    <div className="message message--failed">
                        {localizationFeedback.failedMessage}
                    </div>
                )}

                <form
                    onSubmit={e => {
                        e.preventDefault()
                        e.stopPropagation()
                        this.handleSubmit()
                    }}
                >
                    <input
                        type="text"
                        placeholder={localizationFeedback.name}
                        ref={input => (this._inputValue = input)}
                    />
                   {error.full_name && (
                        <div className="error-message">
                            <Text.span className="tooltip-arrow">arrow</Text.span>
                            {error.full_name[this.props.selectedLanguage]}
                        </div>
                    )}

                    <input
                        type="text"
                        placeholder={localizationFeedback.email}
                        ref={input => (this._emailValue = input)}
                    />
                    {error.email && (
                        <div className="error-message">
                             <Text.span className="tooltip-arrow">arrow</Text.span>
                            {error.email[this.props.selectedLanguage]}
                        </div>
                    )}
                    <textarea
                        placeholder={localizationFeedback.message}
                        ref={textarea => (this._messageValue = textarea)}
                    />
                    {error.feedback && (
                        <div className="error-message">
                            <Text.span className="tooltip-arrow">arrow</Text.span>
                            {error.feedback[this.props.selectedLanguage]}
                        </div>
                    )}
                    <button type="submit" className={`btn--ghost ${this.state.isSubmitting ? 'btn-disabled' : ''}`} disabled={this.state.isSubmitting}>
                        {localizationFeedback.send}
                    </button>
                </form>
            </FeedbackMain>
        )
    }
}

const FeedbackMain = styled.div`
  h2 {
    margin-bottom: 40px;
  }
  .message {
    border-radius: 3px;
    padding: 8px 10px;
    margin-bottom: 14px;
    &--success {
      background: ${props => props.theme.sec.green};
    }
    &--failed {
      background: ${props => props.theme.sec.red};
    }
  }
`

export default withRouter(
    connect(state => ({
        selectedLanguage: state.localizationReducers.selectedLanguage,
    }))(Feedback),
)



// WEBPACK FOOTER //
// ./src/components/layouts/feedback/feedback.js